(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kiss-adviser-avatar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kiss-adviser-avatar')) {
  customElements.define('kiss-adviser-avatar', class extends HTMLElement {
    connectedCallback() {
      this.visible = false;
      this.sync = () => this.toggleAttribute('data-moving', this.visible && !document.hidden);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.sync);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.sync);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-atmosphere"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kiss-atmosphere')) {
    customElements.define('kiss-atmosphere', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.fine = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1000px)');
        this.pointerControllers = new Map();
        this.seen = new WeakSet();
        this.motion.addEventListener('change',() => this.refresh(),{signal:this.controller.signal});
        this.fine.addEventListener('change',() => this.refresh(),{signal:this.controller.signal});
        document.addEventListener('shopify:section:load',() => this.refresh(),{signal:this.controller.signal});
        document.addEventListener('shopify:section:unload',() => this.refresh(),{signal:this.controller.signal});
        document.addEventListener('visibilitychange',() => {
          this.toggleAttribute('data-paused',document.hidden);
          if (document.hidden) this.clearPointers();
          else this.refresh();
        },{signal:this.controller.signal});
        this.refresh();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.clearPointers();
      }
      clearPointers() {
        this.pointerControllers?.forEach((state,element) => {
          state.controller.abort();
          cancelAnimationFrame(state.frame);
          element.removeAttribute('data-km-pointer');
          element.style.removeProperty('--km-pointer-x');
          element.style.removeProperty('--km-pointer-y');
        });
        this.pointerControllers?.clear();
      }
      refresh() {
        this.observer?.disconnect();
        this.clearPointers();
        if (this.motion.matches) {
          document.querySelectorAll('.kiss-mood-enter').forEach(element=>element.classList.remove('kiss-mood-enter'));
          return;
        }
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              const element = entry.target;
              this.observer.unobserve(element);
              if (this.seen.has(element)) return;
              this.seen.add(element);
              element.classList.add('kiss-mood-enter');
              element.addEventListener('animationend',event => {
                if (event.target === element && event.animationName === 'kiss-mood-enter') element.classList.remove('kiss-mood-enter');
              },{signal:this.controller.signal});
            });
          },{threshold:.08});
          document.querySelectorAll('.kiss-home__orbit-intro,.kiss-banners__card,.kiss-finder,.kiss-discovery__trust-card,.kiss-category-card').forEach(element => {
            if (!this.seen.has(element)) this.observer.observe(element);
          });
        }
        if (!this.fine.matches || document.hidden) return;
        document.querySelectorAll('.kiss-home__shopping').forEach(element => {
          const state = {controller:new AbortController(),frame:0};
          const signal = state.controller.signal;
          this.pointerControllers.set(element,state);
          element.addEventListener('pointermove',event => {
            if (event.pointerType !== 'mouse') return;
            state.x = event.clientX;
            state.y = event.clientY;
            if (state.frame) return;
            state.frame = requestAnimationFrame(() => {
              state.frame = 0;
              if (!element.isConnected || this.motion.matches || document.hidden) return;
              const rect = element.getBoundingClientRect();
              element.style.setProperty('--km-pointer-x',Math.round(Math.max(0,Math.min(rect.width,state.x - rect.left))) + 'px');
              element.style.setProperty('--km-pointer-y',Math.round(Math.max(0,Math.min(rect.height,state.y - rect.top))) + 'px');
              element.setAttribute('data-km-pointer','active');
            });
          },{signal,passive:true});
          element.addEventListener('pointerleave',() => {
            cancelAnimationFrame(state.frame);
            state.frame = 0;
            element.removeAttribute('data-km-pointer');
          },{signal,passive:true});
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-home-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kiss-home-finder')) {
    customElements.define('kiss-home-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.config = JSON.parse(this.querySelector('[data-kf-config]').textContent);
        this.text = this.config.strings;
        this.features = {
          vibrating:/titresim|vibrasyon|vibrating/,
          rechargeable:/sarjli|sarj edilebil|usb sarj|rechargeable/,
          remote:/uzaktan.{0,15}(kontrol|kumanda)|kumandali|telefon kontrollu|bluetooth/,
          bluetooth:/bluetooth|telefon kontrollu|uygulama.{0,12}kontrol/,
          suction:/vakum|emici|emme|suction/,
          rabbit:/rabbit|tavsan|cift motor|klitoris uyaricili/,
          wearable:/giyilebilir|giyilebilen/,
          realistic:/realistik|gercekci/,
          cup:/vantu[z s]|vantuz/,
          double:/cift basli|cift uclu/,
          cuffs:/kelepce|baglama|bilek|ayak bag/,
          mask:/maske|goz band/,
          set:/\bset\b|seti|takim/,
          automatic:/otomatik|is[iı]tma|isitmali/,
          vagina:/vajina|vajinal/,
          plug:/plug|tikac|tipa/,
          beads:/boncuk|bogum/,
          metal:/metal|celik/,
          lubricant:/kayganlastirici|lubricant/,
          massage:/masaj/,
          condom:/prezervatif|kondom/,
          waterbased:/su bazli/,
          body:/\bbody\b|bodysuit|vucut corabi/,
          costume:/kostum|hemsire|polis|hizmetci|ogrenci/,
          stockings:/corap|jartiyer/,
          lace:/dantel/,
          ring:/halka|ring/,
          pump:/pompa/,
          sleeve:/kilif|uzatici/
        };
        this.groups = {
          vibrator:['suction','rabbit','remote','bluetooth','wearable','rechargeable'],
          dildo:['realistic','vibrating','rechargeable','cup','double'],
          fantasy:['cuffs','mask','set','metal'],
          masturbator:['realistic','automatic','vibrating','rechargeable','vagina'],
          anal:['plug','beads','metal','vibrating','rechargeable','set'],
          health:['lubricant','massage','condom','waterbased'],
          clothing:['body','costume','stockings','lace','set'],
          penis:['ring','pump','sleeve','vibrating','rechargeable']
        };
        this.category = null;
        this.selected = new Set();
        this.products = [];
        this.currency = 'TRY';
        this.showCategories(false);
      }
      disconnectedCallback() { this.request?.abort(); this.initialized = false; }
      norm(value) { return String(value || '').toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i'); }
      facts(product) {
        const title = this.norm(product.title);
        const tags = this.norm((product.tags || []).filter(t => t.startsWith('kiss-alt-')).join(' ')).replace(/-/g,' ');
        return title + ' ' + tags;
      }
      has(product, key) {
        const text = this.facts(product);
        if (key === 'vibrating' && /titresimsiz|vibrasyonsuz/.test(text)) return false;
        if (key === 'rechargeable' && /sarj(?:li)? degil|pilli/.test(text)) return false;
        return !!this.features[key]?.test(text);
      }
      matches(product, selection = this.selected, budget = this.budget) {
        return product.available === true && !!product.image && Number.isFinite(product.price) &&
          [...selection].every(key => this.has(product,key)) && (budget == null || product.price <= budget);
      }
      node(tag, className, text) {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text != null) element.textContent = text;
        return element;
      }
      part(name) { return this.querySelector('[data-kf-' + name + ']'); }
      button(label, action, primary = false) {
        const b = this.node('button','kiss-finder__button' + (primary ? ' kiss-finder__button--primary' : ''),label);
        b.type = 'button';
        b.addEventListener('click',action);
        return b;
      }
      resetView(step, question, message = '', focus = true) {
        this.part('step').textContent = this.text['step_' + step];
        this.part('question').textContent = question;
        this.part('message').textContent = message;
        this.part('progress').style.width = (Math.min(step,3) / 3 * 100) + '%';
        ['choices','results','actions','summary'].forEach(name => this.part(name).replaceChildren());
        if (this.category && step > 1) {
          this.part('summary').append(this.node('span','',this.text['c_' + this.category.id]));
          if (step > 2) for (const key of this.selected) this.part('summary').append(this.node('span','',this.text['f_' + key]));
        }
        if (focus) this.part('question').focus({preventScroll:true});
      }
      showCategories(focus = true) {
        this.request?.abort();
        this.removeAttribute('aria-busy');
        this.category = null;
        this.selected.clear();
        this.budget = null;
        this.resetView(1,this.text.q_category,'',focus);
        for (const category of this.config.categories.filter(c => c.url)) {
          const b = this.button(this.text['c_' + category.id],() => this.chooseCategory(category));
          b.className = 'kiss-finder__choice';
          this.part('choices').append(b);
        }
      }
      async loadCategory(category, signal) {
        const products = [];
        let page = 1;
        let pages = 1;
        do {
          const url = new URL(category.url,window.location.origin);
          url.searchParams.set('section_id','kiss-finder-data');
          url.searchParams.set('page',String(page));
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id',preview);
          const response = await fetch(url,{signal,credentials:'same-origin'});
          if (!response.ok) throw new Error('catalog');
          const document = new DOMParser().parseFromString(await response.text(),'text/html');
          const data = document.querySelector('[data-kf-catalog]');
          if (!data) throw new Error('catalog');
          const payload = JSON.parse(data.textContent);
          if (!Array.isArray(payload.products) || payload.page !== page) throw new Error('catalog');
          products.push(...payload.products);
          pages = Number(payload.pages) || 1;
          this.currency = payload.currency || 'TRY';
          page++;
          if (page > 100) throw new Error('catalog');
        } while (page <= pages);
        return [...new Map(products.map(p => [p.id,p])).values()];
      }
      async chooseCategory(category) {
        this.request?.abort();
        this.request = new AbortController();
        const signal = this.request.signal;
        this.category = category;
        this.selected.clear();
        this.budget = null;
        this.resetView(2,this.text.q_features,this.text.loading);
        this.setAttribute('aria-busy','true');
        this.part('actions').append(this.button(this.text.back,() => this.showCategories()));
        try {
          const products = await this.loadCategory(category,signal);
          if (signal.aborted || !this.isConnected) return;
          this.products = products;
          this.removeAttribute('aria-busy');
          this.showFeatures();
        } catch (error) {
          if (signal.aborted || !this.isConnected) return;
          this.removeAttribute('aria-busy');
          this.resetView(2,this.text.q_features,this.text.load_error);
          this.part('actions').append(this.button(this.text.back,() => this.showCategories()),this.button(this.text.retry,() => this.chooseCategory(category),true));
          this.browseLink();
        }
      }
      showFeatures(focus = true) {
        this.resetView(2,this.text.q_features,this.text.feature_hint,focus);
        if (!this.products.length) {
          this.part('message').textContent = this.text.no_products;
          this.part('actions').append(this.button(this.text.back,() => this.showCategories()));
          this.browseLink();
          return;
        }
        const keys = this.groups[this.category.id].filter(key => this.products.some(p => this.has(p,key)));
        if (!keys.length) this.part('message').textContent = this.text.no_features;
        for (const key of keys) {
          const b = this.button(this.text['f_' + key],() => {
            this.selected.has(key) ? this.selected.delete(key) : this.selected.add(key);
            this.showFeatures(false);
            this.part('choices').querySelector('[data-feature="' + key + '"]')?.focus({preventScroll:true});
          });
          b.className = 'kiss-finder__choice';
          b.setAttribute('aria-pressed',String(this.selected.has(key)));
          const next = new Set([...this.selected,key]);
          b.disabled = !this.selected.has(key) && !this.products.some(p => this.matches(p,next,null));
          b.dataset.feature = key;
          this.part('choices').append(b);
        }
        this.part('actions').append(this.button(this.text.back,() => this.showCategories()),this.button(this.selected.size ? this.text.continue : this.text.no_preference,() => this.showBudget(),true));
      }
      money(cents) { return new Intl.NumberFormat('tr-TR',{style:'currency',currency:this.currency,maximumFractionDigits:0}).format(cents / 100); }
      showBudget(focus = true) {
        this.resetView(3,this.text.q_budget,this.text.budget_hint,focus);
        const prices = this.products.filter(p => this.matches(p,this.selected,null)).map(p => p.price).sort((a,b) => a-b);
        const unit = this.currency === 'TRY' ? 25000 : 1000;
        const values = [...new Set([.25,.5,.75].map(q => Math.ceil((prices[Math.floor((prices.length - 1) * q)] || unit) / unit) * unit))];
        for (const budget of values) {
          const b = this.button(this.text.up_to.replace('[amount]',this.money(budget)),() => { this.budget = budget; this.showResults(); });
          b.className = 'kiss-finder__choice';
          this.part('choices').append(b);
        }
        const any = this.button(this.text.any_budget,() => {this.budget=null;this.showResults();});
        any.className = 'kiss-finder__choice';
        this.part('choices').append(any);
        const form = this.node('form','kiss-finder__budget');
        const label = this.node('label','',this.text.custom_budget + ' (' + this.currency + ')');
        const input = this.node('input');
        input.type = 'number'; input.min = '1'; input.step = '0.01'; input.inputMode = 'decimal'; input.required = true;
        label.append(input);
        const submit = this.button(this.text.show,() => {});
        submit.type = 'submit';
        form.append(label,submit);
        form.addEventListener('submit',event => {
          event.preventDefault();
          const amount = Number(input.value);
          if (!Number.isFinite(amount) || amount <= 0) return;
          this.budget = Math.round(amount * 100);
          this.showResults();
        });
        this.part('choices').append(form);
        this.part('actions').append(this.button(this.text.back,() => this.showFeatures()));
      }
      rank() {
        const keys = this.groups[this.category.id];
        return this.products.filter(p => this.matches(p)).map(p => ({p,score:keys.filter(k => this.has(p,k)).length})).sort((a,b) => b.score-a.score || a.p.price-b.p.price || String(a.p.id).localeCompare(String(b.p.id))).map(x => x.p);
      }
      showResults() {
        const matches = this.rank();
        this.resetView(4,this.text.result_title,matches.length ? this.text.result_intro : this.text.no_match);
        if (this.budget != null) this.part('summary').append(this.node('span','',this.text.up_to.replace('[amount]',this.money(this.budget))));
        for (const product of matches.slice(0,3)) {
          const url = new URL(product.url,window.location.origin);
          if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) continue;
          const link = this.node('a','kiss-finder__result'); link.href = url.pathname + url.search;
          const image = this.node('img'); image.src=product.image; image.alt=''; image.width=64;image.height=76;image.loading='lazy';
          const copy = this.node('div');
          copy.append(this.node('h4','',product.title));
          const reasons = [...this.selected];
          if (!reasons.length) reasons.push(...this.groups[this.category.id].filter(k => this.has(product,k)).slice(0,2));
          const reasonTemplate = this.selected.size ? this.text.reason : this.text.reason_extra;
          const reason = reasons.length ? reasonTemplate.replace('[features]',reasons.map(k=>this.text['f_'+k].toLocaleLowerCase('tr-TR')).join(', ')) : this.text.reason_category.replace('[category]',this.text['c_'+this.category.id].toLocaleLowerCase('tr-TR'));
          copy.append(this.node('p','',reason),this.node('b','',product.priceText || this.money(product.price)));
          const arrow = this.node('span','','↗'); arrow.setAttribute('aria-hidden','true');
          link.append(image,copy,arrow); this.part('results').append(link);
        }
        this.part('actions').append(this.button(this.text.edit_features,()=>this.showFeatures()),this.button(this.text.edit_budget,()=>this.showBudget()),this.button(this.text.restart,()=>this.showCategories()));
        this.browseLink();
      }
      browseLink() {
        const link = this.node('a','kiss-finder__button',this.text.browse);
        link.href = this.category.url;
        this.part('actions').append(link);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-logo-motion-backup-20260928-v10"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('kiss-logo-motion')) return;
  const duration = 4800;
  const poses = [
    {at:0,man:[0,0,0],woman:[0,0,0]},
    {at:700,man:[-84,8,3],woman:[84,-6,-3]},
    {at:900,man:[-84,8,3],woman:[84,-6,-3]},
    {at:2750,man:[0,0,-12],woman:[0,0,10]},
    {at:3650,man:[0,0,-12],woman:[0,0,10]},
    {at:duration,man:[0,0,0],woman:[0,0,0]}
  ];
  const ease = value => {
    const x = Math.max(0,Math.min(1,value));
    return x*x*x*(x*(x*6-15)+10);
  };
  customElements.define('kiss-logo-motion',class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.button = this.querySelector('[data-kiss-replay]');
      this.man = this.querySelector('[data-kiss-man]');
      this.woman = this.querySelector('[data-kiss-woman]');
      this.word = this.querySelector('[data-kiss-word]');
      if (!this.button || !this.man || !this.woman) return;
      this.controller = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.elapsed = duration;
      this.frameId = null;
      this.previous = null;
      this.running = false;
      this.started = false;
      this.visible = false;
      const signal = this.controller.signal;
      this.button.addEventListener('click',() => this.play(),{signal});
      document.addEventListener('visibilitychange',() => {
        this.previous = null;
        if (document.hidden) this.suspend();
        else this.queue();
      },{signal});
      this.reduced.addEventListener('change',() => {
        if (!this.reduced.matches) return;
        this.running = false;
        this.started = true;
        this.suspend();
        this.draw(duration);
      },{signal});
      this.draw(duration);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.previous = null;
          if (!this.visible) this.suspend();
          else if (!this.started && !this.reduced.matches) this.play();
          else this.queue();
        },{threshold:.15});
        this.observer.observe(this);
      } else {
        this.visible = true;
        if (!this.reduced.matches) this.play();
      }
    }
    disconnectedCallback() {
      this.running = false;
      this.suspend();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
    suspend() {
      if (this.frameId != null) cancelAnimationFrame(this.frameId);
      this.frameId = null;
      this.previous = null;
    }
    queue() {
      if (this.frameId != null || !this.running || !this.visible || document.hidden || !this.isConnected) return;
      this.frameId = requestAnimationFrame(now => this.tick(now));
    }
    play() {
      if (this.reduced.matches) { this.draw(duration); return; }
      this.suspend();
      this.elapsed = 0;
      this.running = true;
      this.started = true;
      this.draw(0);
      this.queue();
    }
    tick(now) {
      this.frameId = null;
      if (!this.running || !this.visible || document.hidden || !this.isConnected) { this.previous = null; return; }
      if (this.previous != null) this.elapsed = Math.min(duration,this.elapsed + Math.max(0,now-this.previous));
      this.previous = now;
      this.draw(this.elapsed);
      if (this.elapsed >= duration) {
        this.running = false;
        this.previous = null;
      } else this.queue();
    }
    draw(time) {
      const t = Math.max(0,Math.min(duration,time));
      let index = 0;
      while (index < poses.length-2 && t > poses[index+1].at) index++;
      const from = poses[index];
      const to = poses[index+1];
      const progress = ease((t-from.at)/(to.at-from.at));
      for (const name of ['man','woman']) {
        const pose = from[name].map((value,i) => value+(to[name][i]-value)*progress);
        this[name].setAttribute('transform',`translate(${pose[0].toFixed(3)} ${pose[1].toFixed(3)}) rotate(${pose[2].toFixed(3)} 800 690)`);
      }
      if (this.word) this.word.setAttribute('opacity',String(ease((t-3700)/650)));
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-logo-motion-backup-20260928-v11-eyes"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'kiss-logo-expression';
  if (customElements.get(tag)) return;
  const duration = 7400;
  const ns = 'http://www.w3.org/2000/svg';
  const numberPattern = /-?\d*\.?\d+(?:e[-+]?\d+)?/gi;
  const smooth = value => {
    const x = Math.max(0, Math.min(1, value));
    return x * x * x * (x * (x * 6 - 15) + 10);
  };
  const ramp = (t, a, b) => smooth((t - a) / (b - a));
  const envelope = (t, a, b, c, d) => ramp(t, a, b) * (1 - ramp(t, c, d));
  const curve = (t, points) => {
    if (t <= points[0][0]) return points[0][1];
    for (let i = 1; i < points.length; i++) {
      if (t <= points[i][0]) {
        const a = points[i - 1], b = points[i];
        return a[1] + (b[1] - a[1]) * ramp(t, a[0], b[0]);
      }
    }
    return points[points.length - 1][1];
  };
  const lipTargets = {
    woman_lips: 'M821 780 C832 775 851 779 861 787 C870 790 869 797 860 800 C849 805 838 814 826 816 C814 819 805 812 804 806 C803 802 809 798 815 796 C805 795 800 790 805 785 C810 781 815 783 821 780 Z',
    woman_teeth: 'M815 794 C825 791 839 792 848 794 C853 796 832 798 815 798 C812 797 812 795 815 794 Z',
    woman_mouth: 'M815 796 C825 794 838 793 850 795 C857 796 834 798 815 798 C814 797 814 797 815 796 Z',
    man_lip: 'M767 791 C778 790 788 792 793 797 C796 802 788 807 780 807 C771 808 760 805 758 801 C758 797 762 793 767 791 Z',
    man_mouth: 'M766 795 C773 794 783 795 789 798 C783 799 773 800 766 799 C764 798 764 797 766 795 Z'
  };
  class KissLogoExpression extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.button = this.querySelector('[data-kiss-replay]');
      this.svg = this.querySelector('svg');
      this.man = this.querySelector('[data-kiss-man]');
      this.woman = this.querySelector('[data-kiss-woman]');
      this.word = this.querySelector('[data-kiss-word]');
      if (!this.button || !this.svg || !this.man || !this.woman) return;
      this.controller = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.frameId = null;
      this.running = false;
      this.started = false;
      this.visible = false;
      this.previous = null;
      this.elapsed = duration;
      this.originalTransforms = [this.man.getAttribute('transform'), this.woman.getAttribute('transform')];
      this.parts = [];
      this.querySelectorAll('[data-kiss-part]').forEach(element => {
        const name = element.dataset.kissPart;
        const d = element.getAttribute('d');
        const numbers = (d.match(numberPattern) || []).map(Number);
        let target = lipTargets[name] ? (lipTargets[name].match(numberPattern) || []).map(Number) : numbers.slice();
        if (name === 'man' || name === 'woman' || name === 'woman_jaw') {
          for (let i = 0; i < numbers.length; i += 2) {
            const x = numbers[i], y = numbers[i + 1];
            if (y <= 740) continue;
            const male = name === 'man';
            const weight = Math.exp(-Math.pow((x - (male ? 769 : 837)) / 44, 2) - Math.pow((y - 818) / 58, 2)) * smooth((y - 740) / 48);
            target[i] += (male ? 13 : -6) * weight;
            target[i + 1] += (male ? -16 : -2) * weight;
          }
        }
        if (numbers.length !== target.length) target = numbers.slice();
        this.parts.push({element, name, d, numbers, target, opacity: element.getAttribute('opacity')});
      });
      this.expressions = [this.makeExpression(this.man, true), this.makeExpression(this.woman, false)];
      const signal = this.controller.signal;
      this.button.addEventListener('click', () => {
        if (this.running) {
          this.running = false;
          this.suspend();
          this.setLabel('resume');
        } else if (this.elapsed < duration && !this.reduced.matches) {
          this.running = true;
          this.setLabel('pause');
          this.queue();
        } else this.play();
      }, {signal});
      document.addEventListener('visibilitychange', () => {
        this.previous = null;
        if (document.hidden) this.suspend();
        else this.queue();
      }, {signal});
      this.reduced.addEventListener('change', () => {
        if (!this.reduced.matches) return;
        this.running = false;
        this.elapsed = duration;
        this.suspend();
        this.restore();
      }, {signal});
      this.restore();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.previous = null;
          if (!this.visible) this.suspend();
          else if (!this.started && !this.reduced.matches) this.play();
          else this.queue();
        }, {threshold: .15});
        this.observer.observe(this);
      } else {
        this.visible = true;
        if (!this.reduced.matches) this.play();
      }
    }
    svgNode(type, attrs) {
      const element = document.createElementNS(ns, type);
      for (const [name, value] of Object.entries(attrs)) element.setAttribute(name, String(value));
      return element;
    }
    makeExpression(parent, male) {
      const group = this.svgNode('g', {'data-kiss-expression': '', opacity: 0, 'aria-hidden': 'true', 'pointer-events': 'none'});
      const x = male ? 715 : 866, y = male ? 697 : 677, w = male ? 34 : 32;
      const brow = this.svgNode('path', {d: '', fill: 'none', stroke: male ? '#8b7a84' : '#9c7c8c', 'stroke-width': 2.1, 'stroke-linecap': 'round', opacity: .65});
      const white = this.svgNode('path', {d: '', fill: '#f5f0f3', stroke: 'none'});
      const pupil = this.svgNode('ellipse', {cx: x + w * (male ? .70 : .30), cy: y, rx: 3.4, ry: 4.0, fill: '#382931'});
      const upper = this.svgNode('path', {d: '', fill: 'none', stroke: '#59414d', 'stroke-width': male ? 2.4 : 2.8, 'stroke-linecap': 'round'});
      const lower = this.svgNode('path', {d: '', fill: 'none', stroke: '#ac929f', 'stroke-width': 1.1, 'stroke-linecap': 'round', opacity: .7});
      group.append(brow, white, pupil, lower, upper);
      parent.append(group);
      return {group, brow, white, pupil, upper, lower, x, y, w, male};
    }
    setLabel(state) {
      const label = this.dataset[state + 'Label'] || this.dataset.playLabel;
      if (label) this.button.setAttribute('aria-label', label);
      this.dataset.motionState = state === 'pause' ? 'playing' : state === 'resume' ? 'paused' : 'idle';
    }
    restore() {
      for (const part of this.parts) {
        part.element.setAttribute('d', part.d);
        if (part.opacity == null) part.element.removeAttribute('opacity');
        else part.element.setAttribute('opacity', part.opacity);
      }
      this.man.setAttribute('transform', this.originalTransforms[0]);
      this.woman.setAttribute('transform', this.originalTransforms[1]);
      for (const expression of this.expressions) expression.group.setAttribute('opacity', '0');
      if (this.word) this.word.setAttribute('opacity', '1');
      this.setLabel('play');
    }
    disconnectedCallback() {
      this.running = false;
      this.suspend();
      this.observer?.disconnect();
      this.controller?.abort();
      if (this.parts) this.restore();
      this.expressions?.forEach(expression => expression.group.remove());
      this.controller = null;
    }
    suspend() {
      if (this.frameId != null) cancelAnimationFrame(this.frameId);
      this.frameId = null;
      this.previous = null;
    }
    queue() {
      if (this.frameId != null || !this.running || !this.visible || document.hidden || !this.isConnected) return;
      this.frameId = requestAnimationFrame(now => this.tick(now));
    }
    play() {
      if (this.reduced.matches) { this.restore(); return; }
      this.suspend();
      this.elapsed = 0;
      this.running = true;
      this.started = true;
      this.setLabel('pause');
      this.draw(0);
      this.queue();
    }
    tick(now) {
      this.frameId = null;
      if (!this.running || !this.visible || document.hidden || !this.isConnected) { this.previous = null; return; }
      if (this.previous != null) this.elapsed = Math.min(duration, this.elapsed + Math.max(0, now - this.previous));
      this.previous = now;
      this.draw(this.elapsed);
      if (this.elapsed >= duration) {
        this.running = false;
        this.previous = null;
        this.restore();
      } else this.queue();
    }
    draw(time) {
      const t = Math.max(0, Math.min(duration, time));
      if (t === 0 || t === duration) { this.restore(); if (this.running && t === 0) this.setLabel('pause'); return; }
      const anticipation = envelope(t, 150, 900, 1400, 2450);
      const approachM = curve(t, [[0,0],[1200,0],[2920,1],[3500,.97],[3910,1],[4500,1],[6100,0],[duration,0]]);
      const approachW = curve(t, [[0,0],[1370,0],[3120,1],[3530,.97],[3990,1],[4550,1],[6200,0],[duration,0]]);
      const pucker = curve(t, [[0,0],[1350,0],[2860,.94],[3550,.92],[3970,1],[4550,1],[5680,.12],[6640,0],[duration,0]]);
      const puckerMale = curve(t, [[0,0],[1550,0],[3120,1],[3600,.96],[3970,1],[4550,1],[5680,.05],[6460,0],[duration,0]]);
      const breath = Math.sin(t / 620) * envelope(t, 180, 800, 5400, 6500);
      this.man.setAttribute('transform', `translate(${(-13 * anticipation).toFixed(3)} ${(1.6 * breath).toFixed(3)}) rotate(${(1.6 * anticipation - 4.8 * approachM).toFixed(3)} 800 690)`);
      this.woman.setAttribute('transform', `translate(${(10 * anticipation).toFixed(3)} ${(-1.1 * breath).toFixed(3)}) rotate(${(-1.3 * anticipation + 3.8 * approachW).toFixed(3)} 800 690)`);
      for (const part of this.parts) {
        const amount = part.name.startsWith('man') ? puckerMale : pucker;
        let index = 0;
        const d = part.d.replace(numberPattern, () => {
          const i = index++;
          return (part.numbers[i] + (part.target[i] - part.numbers[i]) * amount).toFixed(3);
        });
        part.element.setAttribute('d', d);
        if (part.name === 'woman_teeth') part.element.setAttribute('opacity', String(1 - smooth(pucker / .9)));
        if (part.name === 'woman_mouth') part.element.setAttribute('opacity', String(1 - .7 * pucker));
      }
      const expressionOpacity = .88 * envelope(t, 200, 750, 5950, 7040);
      for (const expression of this.expressions) {
        const {x, y, w, male} = expression;
        const blink = male ? envelope(t, 1320, 1410, 1450, 1590) : envelope(t, 940, 1030, 1080, 1250);
        const close = Math.max(blink, envelope(t, male ? 2130 : 2020, male ? 2780 : 2690, male ? 4890 : 5080, 5700));
        const opening = 1 - close;
        const topY = y - 7 * opening + 3 * close;
        const bottomY = y + 5 * opening + 3 * close;
        const upperD = `M${x} ${y} C${x + w*.3} ${topY} ${x + w*.72} ${topY} ${x+w} ${y}`;
        const lowerD = `M${x} ${y} C${x+w*.30} ${bottomY} ${x+w*.72} ${bottomY} ${x+w} ${y}`;
        expression.group.setAttribute('opacity', String(expressionOpacity));
        expression.upper.setAttribute('d', upperD);
        expression.lower.setAttribute('d', lowerD);
        expression.lower.setAttribute('opacity', String(.5 * opening));
        expression.white.setAttribute('d', `${upperD} C${x+w*.72} ${bottomY} ${x+w*.30} ${bottomY} ${x} ${y} Z`);
        expression.pupil.setAttribute('ry', String(3.6 * opening));
        expression.pupil.setAttribute('opacity', String(opening));
        expression.pupil.setAttribute('cx', String(x + w * (male ? .70 : .30)));
        expression.brow.setAttribute('d', `M${x+2} ${y-12} Q${x+w*.5} ${y-18-2*anticipation} ${x+w-1} ${y-11}`);
      }
      if (this.word) this.word.setAttribute('opacity', String(1 - .72 * envelope(t, 200, 950, 5410, 6910)));
    }
  }
  customElements.define(tag, KissLogoExpression);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-logo-motion-backup-20260928-v9"] && !Shopify.designMode) return;
  try {
    const KISS_PATHS = {
  "man": "M513 786 C569 768 622 701 665 663 C703 632 754 643 799 677 C806 673 814 669 820 664 C823 674 818 681 813 686 C804 696 787 702 778 709 C775 719 783 731 789 740 C796 749 781 776 767 793 C765 796 763 798 760 801 C770 809 779 818 779 825 C779 836 766 838 763 849 C758 861 765 879 761 895 C757 915 747 929 724 934 C692 939 550 861 513 786 Z",
  "man_lip": "M760 801 C770 809 779 818 779 825 C779 834 769 838 761 837 C751 836 744 833 738 828 C742 818 752 807 760 801 Z",
  "man_mouth": "M753 800 C758 801 754 809 750 812 C747 815 742 816 740 816 C741 811 748 804 753 800 Z",
  "woman": "M1087 786 C1039 773 1000 741 968 707 C923 660 897 638 859 647 C834 651 814 662 803 677 C798 684 790 689 789 695 C790 701 798 705 807 706 C812 708 813 718 812 729 C808 740 814 758 823 773 C829 782 834 788 839 791 C831 798 823 807 826 820 C829 829 841 835 846 845 C854 858 847 875 852 891 C858 915 874 920 893 916 C910 913 929 909 940 908 C947 908 952 914 954 923 C1007 899 1069 844 1087 786 Z",
  "woman_jaw": "M833 825 C851 837 861 851 858 871 C854 893 860 911 881 912 C930 909 1039 857 1087 786 C1069 844 1007 899 954 923 C952 914 947 908 940 908 C929 909 910 913 893 916 C872 921 858 915 852 891 C847 875 854 858 846 845 C841 835 829 829 833 825 Z",
  "woman_lips": "M814 728 C828 723 853 741 885 756 C905 766 895 778 884 789 C867 805 845 825 834 830 C822 835 819 816 826 805 C829 799 833 794 839 790 C823 777 811 761 808 743 C806 736 808 731 814 728 Z",
  "woman_teeth": "M840 756 C849 751 873 761 891 766 C899 770 875 782 847 788 C839 784 829 766 840 756 Z",
  "woman_mouth": "M845 774 C858 766 878 764 891 767 C903 773 876 783 848 788 C847 785 846 779 845 774 Z"
};
const KISS_FIXED = {
  "man_nose": "M777 706 C785 695 795 687 805 684 C813 680 812 685 808 688 C797 694 785 697 777 706 Z",
  "man_nose_shade": "M748 680 C742 696 748 713 761 716 C773 719 780 712 784 705 C773 713 762 712 755 706 C748 700 747 690 748 680 Z",
  "woman_nose": "M855 649 C866 666 870 680 860 689 C851 698 835 695 829 699 C822 705 823 720 826 730 L815 733 C817 715 810 706 796 705 C788 705 784 699 789 693 C799 682 810 669 825 662 C836 656 846 652 855 649 Z",
  "woman_nostril": "M817 683 C822 682 833 688 830 691 C826 693 821 690 815 690 C807 691 802 695 798 696 C802 689 810 684 817 683 Z"
};
const clampKiss=(x)=>Math.max(0,Math.min(1,x));
const easeKiss=(x)=>{x=clampKiss(x);return x*x*(3-2*x);};
function kissSample(t){
 const m=easeKiss((t-.25)/3.95),f=easeKiss((t-.52)/3.88);
 return {man:[-16*(1-m),3*(1-m),1.35*(1-m)],woman:[12*(1-f),-2*(1-f),-.9*(1-f)],intro:easeKiss(t/.42),word:easeKiss((t-4.65)/1.05)};
}
function kissTransform(p,cx,cy){return `translate(${p[0]} ${p[1]}) rotate(${p[2]} ${cx} ${cy})`;}

if (!window.kissMotionV9Initialized) {
  window.kissMotionV9Initialized = true;
  const kissControllers = new WeakMap();
  const prepareKissMotion = (root) => {
    root.querySelectorAll('[data-kiss-approach]').forEach((button) => {
      if (kissControllers.has(button)) return;
      const svg = button.querySelector('svg');
      const actors = svg.querySelector('[data-kiss-actors]');
      const man = svg.querySelector('[data-kiss-man]');
      const woman = svg.querySelector('[data-kiss-woman]');
      const word = svg.querySelector('[data-kiss-word]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const events = new AbortController();
      let raf = 0, elapsed = 6.4, previous = null, observer;
      const draw = (time) => {
        const s = kissSample(time);
        man.setAttribute('transform',kissTransform(s.man,700,805));
        woman.setAttribute('transform',kissTransform(s.woman,955,785));
        actors.setAttribute('opacity',s.intro);
        word.setAttribute('opacity',s.word);
      };
      const tick = (now) => {
        if (!button.isConnected) { dispose(); return; }
        if (reduced.matches) { draw(6.4); raf=0; return; }
        if (previous !== null) elapsed = Math.min(6.4, elapsed + Math.max(0, (now-previous)/1000));
        previous = now;
        draw(elapsed);
        raf = elapsed < 6.4 ? requestAnimationFrame(tick) : 0;
      };
      const play = () => {
        if (reduced.matches) { draw(6.4); return; }
        if (observer) observer.disconnect();
        cancelAnimationFrame(raf);
        elapsed=0; previous=null;
        draw(0);
        raf=requestAnimationFrame(tick);
      };
      const dispose = () => {
        cancelAnimationFrame(raf);
        if (observer) observer.disconnect();
        events.abort();
        kissControllers.delete(button);
      };
      kissControllers.set(button,{dispose});
      button.addEventListener('click',play,{signal:events.signal});
      reduced.addEventListener('change',() => {
        if (reduced.matches) { cancelAnimationFrame(raf); draw(6.4); }
      },{signal:events.signal});
      draw(6.4);
      if (!reduced.matches) {
        if ('IntersectionObserver' in window) {
          observer=new IntersectionObserver((entries) => {
            if (entries.some((entry)=>entry.isIntersecting)) play();
          },{threshold:.2});
          observer.observe(button);
        } else play();
      }
    });
  };
  prepareKissMotion(document);
  document.addEventListener('shopify:section:load',(event)=>prepareKissMotion(event.target));
  document.addEventListener('shopify:section:unload',(event)=>{
    event.target.querySelectorAll('[data-kiss-approach]').forEach((button)=>kissControllers.get(button)?.dispose());
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-logo-motion-backup-v11-noeyes-before-lips-v12"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'kiss-logo-expression';
  if (customElements.get(tag)) return;
  const duration = 7400;
  const ns = 'http://www.w3.org/2000/svg';
  const numberPattern = /-?\d*\.?\d+(?:e[-+]?\d+)?/gi;
  const smooth = value => {
    const x = Math.max(0, Math.min(1, value));
    return x * x * x * (x * (x * 6 - 15) + 10);
  };
  const ramp = (t, a, b) => smooth((t - a) / (b - a));
  const envelope = (t, a, b, c, d) => ramp(t, a, b) * (1 - ramp(t, c, d));
  const curve = (t, points) => {
    if (t <= points[0][0]) return points[0][1];
    for (let i = 1; i < points.length; i++) {
      if (t <= points[i][0]) {
        const a = points[i - 1], b = points[i];
        return a[1] + (b[1] - a[1]) * ramp(t, a[0], b[0]);
      }
    }
    return points[points.length - 1][1];
  };
  const lipTargets = {
    woman_lips: 'M821 780 C832 775 851 779 861 787 C870 790 869 797 860 800 C849 805 838 814 826 816 C814 819 805 812 804 806 C803 802 809 798 815 796 C805 795 800 790 805 785 C810 781 815 783 821 780 Z',
    woman_teeth: 'M815 794 C825 791 839 792 848 794 C853 796 832 798 815 798 C812 797 812 795 815 794 Z',
    woman_mouth: 'M815 796 C825 794 838 793 850 795 C857 796 834 798 815 798 C814 797 814 797 815 796 Z',
    man_lip: 'M767 791 C778 790 788 792 793 797 C796 802 788 807 780 807 C771 808 760 805 758 801 C758 797 762 793 767 791 Z',
    man_mouth: 'M766 795 C773 794 783 795 789 798 C783 799 773 800 766 799 C764 798 764 797 766 795 Z'
  };
  class KissLogoExpression extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.button = this.querySelector('[data-kiss-replay]');
      this.svg = this.querySelector('svg');
      this.man = this.querySelector('[data-kiss-man]');
      this.woman = this.querySelector('[data-kiss-woman]');
      this.word = this.querySelector('[data-kiss-word]');
      if (!this.button || !this.svg || !this.man || !this.woman) return;
      this.controller = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.frameId = null;
      this.running = false;
      this.started = false;
      this.visible = false;
      this.previous = null;
      this.elapsed = duration;
      this.originalTransforms = [this.man.getAttribute('transform'), this.woman.getAttribute('transform')];
      this.parts = [];
      this.querySelectorAll('[data-kiss-part]').forEach(element => {
        const name = element.dataset.kissPart;
        const d = element.getAttribute('d');
        const numbers = (d.match(numberPattern) || []).map(Number);
        let target = lipTargets[name] ? (lipTargets[name].match(numberPattern) || []).map(Number) : numbers.slice();
        if (name === 'man' || name === 'woman' || name === 'woman_jaw') {
          for (let i = 0; i < numbers.length; i += 2) {
            const x = numbers[i], y = numbers[i + 1];
            if (y <= 740) continue;
            const male = name === 'man';
            const weight = Math.exp(-Math.pow((x - (male ? 769 : 837)) / 44, 2) - Math.pow((y - 818) / 58, 2)) * smooth((y - 740) / 48);
            target[i] += (male ? 13 : -6) * weight;
            target[i + 1] += (male ? -16 : -2) * weight;
          }
        }
        if (numbers.length !== target.length) target = numbers.slice();
        this.parts.push({element, name, d, numbers, target, opacity: element.getAttribute('opacity')});
      });
      this.expressions = [];
      const signal = this.controller.signal;
      this.button.addEventListener('click', () => {
        if (this.running) {
          this.running = false;
          this.suspend();
          this.setLabel('resume');
        } else if (this.elapsed < duration && !this.reduced.matches) {
          this.running = true;
          this.setLabel('pause');
          this.queue();
        } else this.play();
      }, {signal});
      document.addEventListener('visibilitychange', () => {
        this.previous = null;
        if (document.hidden) this.suspend();
        else this.queue();
      }, {signal});
      this.reduced.addEventListener('change', () => {
        if (!this.reduced.matches) return;
        this.running = false;
        this.elapsed = duration;
        this.suspend();
        this.restore();
      }, {signal});
      this.restore();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.previous = null;
          if (!this.visible) this.suspend();
          else if (!this.started && !this.reduced.matches) this.play();
          else this.queue();
        }, {threshold: .15});
        this.observer.observe(this);
      } else {
        this.visible = true;
        if (!this.reduced.matches) this.play();
      }
    }
    svgNode(type, attrs) {
      const element = document.createElementNS(ns, type);
      for (const [name, value] of Object.entries(attrs)) element.setAttribute(name, String(value));
      return element;
    }
    makeExpression(parent, male) {
      const group = this.svgNode('g', {'data-kiss-expression': '', opacity: 0, 'aria-hidden': 'true', 'pointer-events': 'none'});
      const x = male ? 715 : 866, y = male ? 697 : 677, w = male ? 34 : 32;
      const brow = this.svgNode('path', {d: '', fill: 'none', stroke: male ? '#8b7a84' : '#9c7c8c', 'stroke-width': 2.1, 'stroke-linecap': 'round', opacity: .65});
      const white = this.svgNode('path', {d: '', fill: '#f5f0f3', stroke: 'none'});
      const pupil = this.svgNode('ellipse', {cx: x + w * (male ? .70 : .30), cy: y, rx: 3.4, ry: 4.0, fill: '#382931'});
      const upper = this.svgNode('path', {d: '', fill: 'none', stroke: '#59414d', 'stroke-width': male ? 2.4 : 2.8, 'stroke-linecap': 'round'});
      const lower = this.svgNode('path', {d: '', fill: 'none', stroke: '#ac929f', 'stroke-width': 1.1, 'stroke-linecap': 'round', opacity: .7});
      group.append(brow, white, pupil, lower, upper);
      parent.append(group);
      return {group, brow, white, pupil, upper, lower, x, y, w, male};
    }
    setLabel(state) {
      const label = this.dataset[state + 'Label'] || this.dataset.playLabel;
      if (label) this.button.setAttribute('aria-label', label);
      this.dataset.motionState = state === 'pause' ? 'playing' : state === 'resume' ? 'paused' : 'idle';
    }
    restore() {
      for (const part of this.parts) {
        part.element.setAttribute('d', part.d);
        if (part.opacity == null) part.element.removeAttribute('opacity');
        else part.element.setAttribute('opacity', part.opacity);
      }
      this.man.setAttribute('transform', this.originalTransforms[0]);
      this.woman.setAttribute('transform', this.originalTransforms[1]);
      for (const expression of this.expressions) expression.group.setAttribute('opacity', '0');
      if (this.word) this.word.setAttribute('opacity', '1');
      this.setLabel('play');
    }
    disconnectedCallback() {
      this.running = false;
      this.suspend();
      this.observer?.disconnect();
      this.controller?.abort();
      if (this.parts) this.restore();
      this.expressions?.forEach(expression => expression.group.remove());
      this.controller = null;
    }
    suspend() {
      if (this.frameId != null) cancelAnimationFrame(this.frameId);
      this.frameId = null;
      this.previous = null;
    }
    queue() {
      if (this.frameId != null || !this.running || !this.visible || document.hidden || !this.isConnected) return;
      this.frameId = requestAnimationFrame(now => this.tick(now));
    }
    play() {
      if (this.reduced.matches) { this.restore(); return; }
      this.suspend();
      this.elapsed = 0;
      this.running = true;
      this.started = true;
      this.setLabel('pause');
      this.draw(0);
      this.queue();
    }
    tick(now) {
      this.frameId = null;
      if (!this.running || !this.visible || document.hidden || !this.isConnected) { this.previous = null; return; }
      if (this.previous != null) this.elapsed = Math.min(duration, this.elapsed + Math.max(0, now - this.previous));
      this.previous = now;
      this.draw(this.elapsed);
      if (this.elapsed >= duration) {
        this.running = false;
        this.previous = null;
        this.restore();
      } else this.queue();
    }
    draw(time) {
      const t = Math.max(0, Math.min(duration, time));
      if (t === 0 || t === duration) { this.restore(); if (this.running && t === 0) this.setLabel('pause'); return; }
      const anticipation = envelope(t, 150, 900, 1400, 2450);
      const approachM = curve(t, [[0,0],[1200,0],[2920,1],[3500,.97],[3910,1],[4500,1],[6100,0],[duration,0]]);
      const approachW = curve(t, [[0,0],[1370,0],[3120,1],[3530,.97],[3990,1],[4550,1],[6200,0],[duration,0]]);
      const pucker = curve(t, [[0,0],[1350,0],[2860,.94],[3550,.92],[3970,1],[4550,1],[5680,.12],[6640,0],[duration,0]]);
      const puckerMale = curve(t, [[0,0],[1550,0],[3120,1],[3600,.96],[3970,1],[4550,1],[5680,.05],[6460,0],[duration,0]]);
      const breath = Math.sin(t / 620) * envelope(t, 180, 800, 5400, 6500);
      this.man.setAttribute('transform', `translate(${(-13 * anticipation).toFixed(3)} ${(1.6 * breath).toFixed(3)}) rotate(${(1.6 * anticipation - 4.8 * approachM).toFixed(3)} 800 690)`);
      this.woman.setAttribute('transform', `translate(${(10 * anticipation).toFixed(3)} ${(-1.1 * breath).toFixed(3)}) rotate(${(-1.3 * anticipation + 3.8 * approachW).toFixed(3)} 800 690)`);
      for (const part of this.parts) {
        const amount = part.name.startsWith('man') ? puckerMale : pucker;
        let index = 0;
        const d = part.d.replace(numberPattern, () => {
          const i = index++;
          return (part.numbers[i] + (part.target[i] - part.numbers[i]) * amount).toFixed(3);
        });
        part.element.setAttribute('d', d);
        if (part.name === 'woman_teeth') part.element.setAttribute('opacity', String(1 - smooth(pucker / .9)));
        if (part.name === 'woman_mouth') part.element.setAttribute('opacity', String(1 - .7 * pucker));
      }
      const expressionOpacity = .88 * envelope(t, 200, 750, 5950, 7040);
      for (const expression of this.expressions) {
        const {x, y, w, male} = expression;
        const blink = male ? envelope(t, 1320, 1410, 1450, 1590) : envelope(t, 940, 1030, 1080, 1250);
        const close = Math.max(blink, envelope(t, male ? 2130 : 2020, male ? 2780 : 2690, male ? 4890 : 5080, 5700));
        const opening = 1 - close;
        const topY = y - 7 * opening + 3 * close;
        const bottomY = y + 5 * opening + 3 * close;
        const upperD = `M${x} ${y} C${x + w*.3} ${topY} ${x + w*.72} ${topY} ${x+w} ${y}`;
        const lowerD = `M${x} ${y} C${x+w*.30} ${bottomY} ${x+w*.72} ${bottomY} ${x+w} ${y}`;
        expression.group.setAttribute('opacity', String(expressionOpacity));
        expression.upper.setAttribute('d', upperD);
        expression.lower.setAttribute('d', lowerD);
        expression.lower.setAttribute('opacity', String(.5 * opening));
        expression.white.setAttribute('d', `${upperD} C${x+w*.72} ${bottomY} ${x+w*.30} ${bottomY} ${x} ${y} Z`);
        expression.pupil.setAttribute('ry', String(3.6 * opening));
        expression.pupil.setAttribute('opacity', String(opening));
        expression.pupil.setAttribute('cx', String(x + w * (male ? .70 : .30)));
        expression.brow.setAttribute('d', `M${x+2} ${y-12} Q${x+w*.5} ${y-18-2*anticipation} ${x+w-1} ${y-11}`);
      }
      if (this.word) this.word.setAttribute('opacity', String(1 - .72 * envelope(t, 200, 950, 5410, 6910)));
    }
  }
  customElements.define(tag, KissLogoExpression);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-logo-motion-backup-v12-before-head-v13"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'kiss-logo-expression';
  if (customElements.get(tag)) return;
  const duration = 7400;
  const numberPattern = /-?\d*\.?\d+(?:e[-+]?\d+)?/gi;
  const smooth = value => {
    const x = Math.max(0, Math.min(1, value));
    return x * x * x * (x * (x * 6 - 15) + 10);
  };
  const ramp = (t, a, b) => smooth((t - a) / (b - a));
  const envelope = (t, a, b, c, d) => ramp(t, a, b) * (1 - ramp(t, c, d));
  const curve = (t, points) => {
    if (t <= points[0][0]) return points[0][1];
    for (let i = 1; i < points.length; i++) {
      if (t <= points[i][0]) {
        const a = points[i - 1], b = points[i];
        return a[1] + (b[1] - a[1]) * ramp(t, a[0], b[0]);
      }
    }
    return points[points.length - 1][1];
  };
  // Resting artwork is restored verbatim; motion timing and head transforms are unchanged.
  const mouthTargets = {
    "man": "M513 786 C569 768 622 701 665 663 C703 632 754 643 799 677 C806 673 814 669 820 664 C823 674 818 681 813 686 C804 696 787 702 778 709 C775 719 783 731 789 740 C796 749 777 770 769 783 C772 788 787 790 791 795 C794 800 787 806 779 812 C768 821 767 836 763 849 C758 861 765 879 761 895 C757 915 747 929 724 934 C692 939 550 861 513 786 Z",
    "man_lip": "M773 800 C780 801 786 800 791 798 C790 801 785 804 779 805 C775 805 772 804 771 803 C771 802 772 801 773 800 Z",
    "man_mouth": "M771 796 C778 796 786 797 791 798 C786 799 778 799 771 798 C769 798 769 797 771 796 Z",
    "woman": "M1087 786 C1039 773 1000 741 968 707 C923 660 897 638 859 647 C834 651 814 662 803 677 C798 684 790 689 789 695 C790 701 798 705 807 706 C812 708 813 718 812 729 C808 740 819 757 824 778 C824 786 822 791 819 798 C815 804 820 813 826 820 C829 829 841 835 846 845 C854 858 847 875 852 891 C858 915 874 920 893 916 C910 913 929 909 940 908 C947 908 952 914 954 923 C1007 899 1069 844 1087 786 Z",
    "woman_jaw": "M833 825 C851 837 861 851 858 871 C854 893 860 911 881 912 C930 909 1039 857 1087 786 C1069 844 1007 899 954 923 C952 914 947 908 940 908 C929 909 910 913 893 916 C872 921 858 915 852 891 C847 875 854 858 846 845 C841 835 829 829 833 825 Z",
    "woman_lips": "M821 780 C830 778 838 787 845 793 C850 798 842 804 836 807 C828 812 821 815 815 811 C809 810 806 806 808 801 C809 799 810 798 809 797 C804 795 806 789 811 785 C814 782 817 780 821 780 Z",
    "woman_teeth": "M816 796.9 C823 796.7 835 796.6 843 796.7 C845 796.9 829 797.1 816 797.1 C815 797.1 815 797 816 796.9 Z",
    "woman_mouth": "M809 797 C820 797 833 796 847 797 C848 798 831 799 809 798.5 C809 798 809 798 809 797 Z"
};
  const closedTargets = {
    "man": "M513.000 786.000 C569.000 768.000 622.000 701.000 665.000 663.000 C703.000 632.000 754.000 643.000 799.000 677.000 C806.000 673.000 814.000 669.000 820.000 664.000 C823.000 674.000 818.000 681.000 813.000 686.000 C804.000 696.000 787.000 702.000 778.000 709.000 C775.000 719.000 783.000 731.000 789.000 740.000 C796.000 749.000 778.520 772.280 768.240 786.800 C769.340 791.040 777.880 793.040 779.220 797.280 C784.880 803.420 783.960 810.560 779.000 816.940 C772.180 826.700 766.620 836.760 763.000 849.000 C758.000 861.000 765.000 879.000 761.000 895.000 C757.000 915.000 747.000 929.000 724.000 934.000 C692.000 939.000 550.000 861.000 513.000 786.000 Z",
    "man_lip": "M768.060 800.380 C776.200 804.040 783.340 806.840 786.440 808.260 C785.820 813.540 778.920 816.920 772.160 817.160 C765.880 816.780 761.360 815.020 758.460 812.500 C759.980 808.080 764.400 803.280 768.060 800.380 Z",
    "man_mouth": "M764.160 797.520 C770.400 797.900 773.840 801.560 775.420 803.320 C771.180 805.080 764.320 805.460 759.220 804.840 C758.360 802.940 761.020 799.660 764.160 797.520 Z",
    "woman": "M1087.000 786.000 C1039.000 773.000 1000.000 741.000 968.000 707.000 C923.000 660.000 897.000 638.000 859.000 647.000 C834.000 651.000 814.000 662.000 803.000 677.000 C798.000 684.000 790.000 689.000 789.000 695.000 C790.000 701.000 798.000 705.000 807.000 706.000 C812.000 708.000 813.000 718.000 812.000 729.000 C808.000 740.000 817.100 757.380 823.620 776.100 C825.900 784.480 826.560 789.860 826.600 795.340 C821.080 801.720 821.140 810.720 826.000 820.000 C829.000 829.000 841.000 835.000 846.000 845.000 C854.000 858.000 847.000 875.000 852.000 891.000 C858.000 915.000 874.000 920.000 893.000 916.000 C910.000 913.000 929.000 909.000 940.000 908.000 C947.000 908.000 952.000 914.000 954.000 923.000 C1007.000 899.000 1069.000 844.000 1087.000 786.000 Z",
    "woman_jaw": "M833.000 825.000 C851.000 837.000 861.000 851.000 858.000 871.000 C854.000 893.000 860.000 911.000 881.000 912.000 C930.000 909.000 1039.000 857.000 1087.000 786.000 C1069.000 844.000 1007.000 899.000 954.000 923.000 C952.000 914.000 947.000 908.000 940.000 908.000 C929.000 909.000 910.000 913.000 893.000 916.000 C872.000 921.000 858.000 915.000 852.000 891.000 C847.000 875.000 854.000 858.000 846.000 845.000 C841.000 835.000 829.000 829.000 833.000 825.000 Z",
    "woman_lips": "M817 749 C833 746 852 763 860 778 C866 788 854 799 844 806 C833 816 824 823 817 818 C810 815 807 809 812 803 C814 799 816 796 817 794 C809 787 807 769 808 758 C809 754 812 750 817 749 Z",
    "woman_teeth": "M821 792 C832 790 847 787 857 787 C861 789 840 793 821 794 C819 794 819 793 821 792 Z",
    "woman_mouth": "M817 794 C831 791 847 787 861 786 C865 789 842 794 818 796 C817 795 817 795 817 794 Z"
};
  class KissLogoExpression extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.button = this.querySelector('[data-kiss-replay]');
      this.svg = this.querySelector('svg');
      this.man = this.querySelector('[data-kiss-man]');
      this.woman = this.querySelector('[data-kiss-woman]');
      this.word = this.querySelector('[data-kiss-word]');
      if (!this.button || !this.svg || !this.man || !this.woman) return;
      this.controller = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.frameId = null;
      this.running = false;
      this.started = false;
      this.visible = false;
      this.previous = null;
      this.elapsed = duration;
      this.originalTransforms = [this.man.getAttribute('transform'), this.woman.getAttribute('transform')];
      this.parts = [];
      this.querySelectorAll('[data-kiss-part]').forEach(element => {
        const name = element.dataset.kissPart;
        const d = element.getAttribute('d');
        const numbers = (d.match(numberPattern) || []).map(Number);
        const target = mouthTargets[name] ? (mouthTargets[name].match(numberPattern) || []).map(Number) : numbers.slice();
        const closed = closedTargets[name] ? (closedTargets[name].match(numberPattern) || []).map(Number) : numbers.slice();
        const compatible = target.length === numbers.length && closed.length === numbers.length;
        this.parts.push({element, name, d, numbers,
          target: compatible ? target : numbers.slice(),
          closed: compatible ? closed : numbers.slice(),
          opacity: element.getAttribute('opacity'), fill: element.getAttribute('fill')});
      });
      const signal = this.controller.signal;
      this.button.addEventListener('click', () => {
        if (this.running) {
          this.running = false;
          this.suspend();
          this.setLabel('resume');
        } else if (this.elapsed < duration && !this.reduced.matches) {
          this.running = true;
          this.setLabel('pause');
          this.queue();
        } else this.play();
      }, {signal});
      document.addEventListener('visibilitychange', () => {
        this.previous = null;
        if (document.hidden) this.suspend();
        else this.queue();
      }, {signal});
      this.reduced.addEventListener('change', () => {
        if (!this.reduced.matches) return;
        this.running = false;
        this.elapsed = duration;
        this.suspend();
        this.restore();
      }, {signal});
      this.restore();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.previous = null;
          if (!this.visible) this.suspend();
          else if (!this.started && !this.reduced.matches) this.play();
          else this.queue();
        }, {threshold: .15});
        this.observer.observe(this);
      } else {
        this.visible = true;
        if (!this.reduced.matches) this.play();
      }
    }
    setLabel(state) {
      const label = this.dataset[state + 'Label'] || this.dataset.playLabel;
      if (label) this.button.setAttribute('aria-label', label);
      this.dataset.motionState = state === 'pause' ? 'playing' : state === 'resume' ? 'paused' : 'idle';
    }
    restore() {
      for (const part of this.parts) {
        part.element.setAttribute('d', part.d);
        if (part.opacity == null) part.element.removeAttribute('opacity');
        else part.element.setAttribute('opacity', part.opacity);
        if (part.fill != null) part.element.setAttribute('fill', part.fill);
      }
      this.man.setAttribute('transform', this.originalTransforms[0]);
      this.woman.setAttribute('transform', this.originalTransforms[1]);
      if (this.word) this.word.setAttribute('opacity', '1');
      this.setLabel('play');
    }
    disconnectedCallback() {
      this.running = false;
      this.suspend();
      this.observer?.disconnect();
      this.controller?.abort();
      if (this.parts) this.restore();
      this.controller = null;
    }
    suspend() {
      if (this.frameId != null) cancelAnimationFrame(this.frameId);
      this.frameId = null;
      this.previous = null;
    }
    queue() {
      if (this.frameId != null || !this.running || !this.visible || document.hidden || !this.isConnected) return;
      this.frameId = requestAnimationFrame(now => this.tick(now));
    }
    play() {
      if (this.reduced.matches) { this.restore(); return; }
      this.suspend();
      this.elapsed = 0;
      this.running = true;
      this.started = true;
      this.setLabel('pause');
      this.draw(0);
      this.queue();
    }
    tick(now) {
      this.frameId = null;
      if (!this.running || !this.visible || document.hidden || !this.isConnected) { this.previous = null; return; }
      if (this.previous != null) this.elapsed = Math.min(duration, this.elapsed + Math.max(0, now - this.previous));
      this.previous = now;
      this.draw(this.elapsed);
      if (this.elapsed >= duration) {
        this.running = false;
        this.previous = null;
        this.restore();
      } else this.queue();
    }
    draw(time) {
      const t = Math.max(0, Math.min(duration, time));
      if (t === 0 || t === duration) { this.restore(); if (this.running && t === 0) this.setLabel('pause'); return; }
      const anticipation = envelope(t, 150, 900, 1400, 2450);
      const approachM = curve(t, [[0,0],[1200,0],[2920,1],[3500,.97],[3910,1],[4500,1],[6100,0],[duration,0]]);
      const approachW = curve(t, [[0,0],[1370,0],[3120,1],[3530,.97],[3990,1],[4550,1],[6200,0],[duration,0]]);
      const pucker = curve(t, [[0,0],[1350,0],[2860,.94],[3550,.92],[3970,1],[4550,1],[5680,.12],[6640,0],[duration,0]]);
      const puckerMale = curve(t, [[0,0],[1550,0],[3120,1],[3600,.96],[3970,1],[4550,1],[5680,.05],[6460,0],[duration,0]]);
      const breath = Math.sin(t / 620) * envelope(t, 180, 800, 5400, 6500);
      this.man.setAttribute('transform', `translate(${(-13 * anticipation).toFixed(3)} ${(1.6 * breath).toFixed(3)}) rotate(${(1.6 * anticipation - 4.8 * approachM).toFixed(3)} 800 690)`);
      this.woman.setAttribute('transform', `translate(${(10 * anticipation).toFixed(3)} ${(-1.1 * breath).toFixed(3)}) rotate(${(-1.3 * anticipation + 3.8 * approachW).toFixed(3)} 800 690)`);
      for (const part of this.parts) {
        const amount = part.name.startsWith('man') ? puckerMale : pucker;
        // Close the aperture first, then gently purse. Both poses share the same path topology.
        const closing = amount <= .52;
        const from = closing ? part.numbers : part.closed;
        const to = closing ? part.closed : part.target;
        const blend = smooth(closing ? amount / .52 : (amount - .52) / .48);
        let index = 0;
        const d = part.d.replace(numberPattern, () => {
          const i = index++;
          return (from[i] + (to[i] - from[i]) * blend).toFixed(3);
        });
        part.element.setAttribute('d', d);
        // Teeth withdraw while the dark opening becomes a fine lip seam, rather than a fading oval.
        if (part.name === 'woman_teeth') part.element.setAttribute('opacity', String(1 - smooth(pucker / .52)));
        if (part.name === 'woman_mouth') {
          const shade = smooth(pucker / .52);
          part.element.setAttribute('opacity', '1');
          part.element.setAttribute('fill', `rgb(${Math.round(6 + 112 * shade)},${Math.round(6 - 6 * shade)},${Math.round(6 + 3 * shade)})`);
        }
        if (part.name === 'man_lip') part.element.setAttribute('opacity', String(1 - .18 * smooth(puckerMale)));
      }
      if (this.word) this.word.setAttribute('opacity', String(1 - .72 * envelope(t, 200, 950, 5410, 6910)));
    }
  }
  customElements.define(tag, KissLogoExpression);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-logo-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'kiss-logo-approach';
  if (customElements.get(tag)) return;
  const duration = 6400;
  function poseAt(t) {
    const seconds = t / 1000;
    const ease = value => {
      const x = Math.max(0, Math.min(1, value));
      return x*x*(3-2*x);
    };
    const man = ease((seconds-.25)/3.95);
    const woman = ease((seconds-.52)/3.88);
    return {
      man: [-16*(1-man),3*(1-man),1.35*(1-man)],
      woman: [12*(1-woman),-2*(1-woman),-.9*(1-woman)],
      word: 1
    };
  }
  class KissLogoApproach extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.button = this.querySelector('[data-kiss-replay]');
      this.man = this.querySelector('[data-kiss-man]');
      this.woman = this.querySelector('[data-kiss-woman]');
      this.word = this.querySelector('[data-kiss-word]');
      if (!this.button || !this.man || !this.woman) return;
      this.controller = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.originalTransforms = [this.man.getAttribute('transform'),this.woman.getAttribute('transform')];
      this.originalWordOpacity = this.word?.getAttribute('opacity');
      this.frameId = null;
      this.previous = null;
      this.running = false;
      this.started = false;
      this.visible = false;
      this.elapsed = duration;
      const signal = this.controller.signal;
      this.button.addEventListener('click',() => {
        if (this.running) {
          this.running = false;
          this.suspend();
          this.setLabel('resume');
        } else if (this.elapsed < duration && !this.reduced.matches) {
          this.running = true;
          this.setLabel('pause');
          this.queue();
        } else this.play();
      },{signal});
      document.addEventListener('visibilitychange',() => {
        this.previous = null;
        if (document.hidden) this.suspend();
        else this.queue();
      },{signal});
      this.reduced.addEventListener('change',() => {
        if (this.reduced.matches) {
          this.running = false;
          this.elapsed = duration;
          this.suspend();
          this.restore();
        }
      },{signal});
      this.restore();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.previous = null;
          if (!this.visible) this.suspend();
          else if (!this.started && !this.reduced.matches) this.play();
          else this.queue();
        },{threshold:.15});
        this.observer.observe(this);
      } else {
        this.visible = true;
        if (!this.reduced.matches) this.play();
      }
    }
    setLabel(state) {
      const label = this.dataset[state+'Label'] || this.dataset.playLabel;
      if (label) this.button.setAttribute('aria-label',label);
      this.dataset.motionState = state === 'pause' ? 'playing' : state === 'resume' ? 'paused' : 'idle';
    }
    restore() {
      [this.man,this.woman].forEach((element,i) => {
        if (this.originalTransforms[i] == null) element.removeAttribute('transform');
        else element.setAttribute('transform',this.originalTransforms[i]);
      });
      if (this.word) {
        if (this.originalWordOpacity == null) this.word.removeAttribute('opacity');
        else this.word.setAttribute('opacity',this.originalWordOpacity);
      }
      this.setLabel('play');
    }
    disconnectedCallback() {
      this.running = false;
      this.suspend();
      this.observer?.disconnect();
      this.controller?.abort();
      if (this.originalTransforms) this.restore();
      this.controller = null;
    }
    suspend() {
      if (this.frameId != null) cancelAnimationFrame(this.frameId);
      this.frameId = null;
      this.previous = null;
    }
    queue() {
      if (this.frameId != null || !this.running || !this.visible || document.hidden || !this.isConnected) return;
      this.frameId = requestAnimationFrame(now => this.tick(now));
    }
    play() {
      if (this.reduced.matches) { this.restore(); return; }
      this.suspend();
      this.elapsed = 0;
      this.running = true;
      this.started = true;
      this.setLabel('pause');
      this.draw(0);
      this.queue();
    }
    tick(now) {
      this.frameId = null;
      if (!this.running || !this.visible || document.hidden || !this.isConnected) { this.previous = null; return; }
      if (this.previous != null) this.elapsed = Math.min(duration,this.elapsed+Math.max(0,now-this.previous));
      this.previous = now;
      this.draw(this.elapsed);
      if (this.elapsed >= duration) {
        this.running = false;
        this.previous = null;
        this.restore();
      } else this.queue();
    }
    draw(time) {
      const t = Math.max(0,Math.min(duration,time));
      if (t >= duration) { this.restore(); return; }
      const state = poseAt(t);
      for (const name of ['man','woman']) {
        const p = state[name];
        this[name].setAttribute('transform',`translate(${p[0].toFixed(4)} ${p[1].toFixed(4)}) rotate(${p[2].toFixed(4)} ${name === 'man' ? '700 805' : '955 785'})`);
      }
      if (this.word) this.word.setAttribute('opacity',String(state.word));
    }
  }
  customElements.define(tag,KissLogoApproach);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-orbit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kiss-orbit')) {
    customElements.define('kiss-orbit', class extends HTMLElement {
      connectedCallback() {
        if (this.orbitController) return;
        this.orbitController = new AbortController();
        this.stage = this.querySelector('.kiss-orbit__stage');
        this.items = Array.from(this.querySelectorAll('[data-orbit-item]'));
        this.details = Array.from(this.querySelectorAll('[data-orbit-detail]'));
        this.count = this.items.length;
        if (!this.count) return;
        this.position = 0;
        this.target = 0;
        this.active = -1;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const signal = this.orbitController.signal;
        this.querySelector('[data-orbit-prev]').addEventListener('click', () => this.go(this.target - 1), { signal });
        this.querySelector('[data-orbit-next]').addEventListener('click', () => this.go(this.target + 1), { signal });
        this.querySelectorAll('.kiss-orbit__arrow').forEach(button => button.disabled = this.count < 2);
        this.stage.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = this.target + 1;
          if (event.key === 'ArrowLeft') next = this.target - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.count - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.stage.focus({ preventScroll: true });
          this.go(next);
        }, { signal });
        this.stage.addEventListener('pointerdown', event => this.startDrag(event), { signal });
        this.stage.addEventListener('pointermove', event => this.drag(event), { signal });
        this.stage.addEventListener('pointerup', event => this.endDrag(event), { signal });
        this.stage.addEventListener('pointercancel', event => this.endDrag(event, true), { signal });
        this.stage.addEventListener('lostpointercapture', event => {
          if (event.target === this.stage) this.endDrag(event, true);
        }, { signal });
        this.stage.addEventListener('click', event => {
          if (performance.now() < (this.suppressUntil || 0)) { event.preventDefault(); return; }
          const index = this.items.indexOf(event.target.closest('[data-orbit-item]'));
          if (index < 0) return;
          const wrapped = this.wrap(this.target);
          let delta = index - wrapped;
          if (delta > this.count / 2) delta -= this.count;
          if (delta < -this.count / 2) delta += this.count;
          this.go(this.target + delta);
        }, { signal });
        this.lightbox = this.querySelector('[data-orbit-lightbox]');
        this.lightboxImage = this.querySelector('[data-orbit-lightbox-image]');
        this.details.forEach((detail, index) => detail.querySelectorAll('[data-orbit-photo]').forEach((button, photoIndex) => {
          button.addEventListener('click', () => {
            this.galleryPhotos = Array.from(detail.querySelectorAll('[data-orbit-photo]'));
            this.querySelector('[data-orbit-lightbox-title]').textContent = this.items[index].getAttribute('aria-label');
            this.showPhoto(photoIndex);
            this.lightbox.showModal();
          }, { signal });
        }));
        this.querySelector('[data-orbit-lightbox-close]').addEventListener('click', () => this.lightbox.close(), { signal });
        this.querySelector('[data-orbit-lightbox-prev]').addEventListener('click', () => this.showPhoto(this.galleryIndex - 1), { signal });
        this.querySelector('[data-orbit-lightbox-next]').addEventListener('click', () => this.showPhoto(this.galleryIndex + 1), { signal });
        this.lightbox.addEventListener('click', event => { if (event.target === this.lightbox) this.lightbox.close(); }, { signal });
        this.lightbox.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.showPhoto(this.galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        const photoFrame = this.querySelector('[data-orbit-lightbox-frame]');
        photoFrame.addEventListener('pointerdown', event => { if (event.isPrimary) this.photoPointer = { x: event.clientX, y: event.clientY }; }, { signal });
        photoFrame.addEventListener('pointerup', event => {
          if (!this.photoPointer) return;
          const dx = event.clientX - this.photoPointer.x;
          const dy = event.clientY - this.photoPointer.y;
          this.photoPointer = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) this.showPhoto(this.galleryIndex + (dx < 0 ? 1 : -1));
        }, { signal });
        photoFrame.addEventListener('pointercancel', () => this.photoPointer = null, { signal });
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.stage);
        this.measure();
        this.select(0, false);
        this.classList.add('is-ready');
      }
      disconnectedCallback() {
        if (this.lightbox?.open) this.lightbox.close();
        this.orbitController?.abort();
        this.orbitController = null;
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
      wrap(value) { return ((value % this.count) + this.count) % this.count; }
      showPhoto(index) {
        if (!this.galleryPhotos?.length) return;
        const count = this.galleryPhotos.length;
        this.galleryIndex = ((index % count) + count) % count;
        const photo = this.galleryPhotos[this.galleryIndex];
        this.lightboxImage.src = photo.dataset.orbitPhoto;
        this.lightboxImage.alt = photo.dataset.orbitAlt;
        this.querySelector('[data-orbit-lightbox-counter]').textContent = `${this.galleryIndex + 1} / ${count}`;
        this.querySelectorAll('[data-orbit-lightbox-prev], [data-orbit-lightbox-next]').forEach(button => button.disabled = count < 2);
      }
      measure() {
        this.width = this.stage.clientWidth;
        this.compact = this.items[0].offsetWidth < 200;
        this.radius = Math.max(40, (this.width - this.items[0].offsetWidth * .6) / 2 - 8);
        const split = !!this.closest('.kiss-home__shopping');
        if (this.compact && !split) this.radius = Math.max(this.radius, this.items[0].offsetWidth * .94);
        this.depth = split ? 132 : (this.compact ? 185 : 260);
        this.split = split;
        this.dragStep = Math.max(90, Math.min(190, this.width / 3));
        this.paint();
      }
      paint() {
        this.items.forEach((item, index) => {
          const angle = (index - this.position) * Math.PI * 2 / this.count;
          const front = (Math.cos(angle) + 1) / 2;
          const x = Math.sin(angle) * this.radius;
          const y = -(1 - front) * this.depth;
          const scale = .28 + .72 * Math.pow(front, this.split ? 3.2 : (this.compact ? 8 : 1.8));
          item.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0) scale(${scale.toFixed(4)})`;
          item.style.zIndex = String(Math.round(front * 100) + 1);
          item.style.opacity = String(.55 + front * .45);
        });
      }
      select(index, announce = true) {
        if (index === this.active) return;
        this.active = index;
        this.items.forEach((item, i) => {
          item.classList.toggle('is-current', i === index);
          item.setAttribute('aria-pressed', String(i === index));
          item.tabIndex = i === index ? 0 : -1;
          this.details[i].hidden = i !== index;
        });
        if (announce) {
          const label = this.dataset.positionLabel.replace('[current]', String(index + 1)).replace('[total]', String(this.count));
          this.querySelector('[data-orbit-status]').textContent = `${label}: ${this.items[index].getAttribute('aria-label')}`;
        }
      }
      go(value) {
        cancelAnimationFrame(this.frame);
        this.target = Math.round(value);
        this.select(this.wrap(this.target));
        if (this.motion.matches) { this.position = this.target; this.paint(); return; }
        const from = this.position;
        const distance = this.target - from;
        const start = performance.now();
        const tick = now => {
          const t = Math.min(1, (now - start) / 620);
          this.position = from + distance * (1 - Math.pow(1 - t, 4));
          this.paint();
          if (t < 1) this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      startDrag(event) {
        if (!event.isPrimary || event.button !== 0 || this.count < 2) return;
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, start: this.position, dragging: false };
      }
      drag(event) {
        const pointer = this.pointer;
        if (!pointer || pointer.id !== event.pointerId) return;
        const dx = event.clientX - pointer.x;
        const dy = event.clientY - pointer.y;
        if (!pointer.dragging) {
          if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { this.pointer = null; return; }
          if (Math.abs(dx) < 9) return;
          pointer.dragging = true;
          cancelAnimationFrame(this.frame);
          pointer.start = this.position;
          this.stage.setPointerCapture(event.pointerId);
          this.stage.classList.add('is-dragging');
        }
        this.position = pointer.start - dx / this.dragStep;
        this.paint();
      }
      endDrag(event, cancelled = false) {
        const pointer = this.pointer;
        if (!pointer || pointer.id !== event.pointerId) return;
        this.pointer = null;
        this.stage.classList.remove('is-dragging');
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
        if (!pointer.dragging) return;
        this.suppressUntil = performance.now() + 350;
        const distance = this.position - pointer.start;
        const next = Math.abs(distance) > .2 && Math.abs(distance) < .5 && !cancelled ? Math.round(pointer.start) + Math.sign(distance) : Math.round(this.position);
        this.go(next);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-packaging-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.kissPackagingV1) return;
  window.kissPackagingV1 = true;
  const controllers = new WeakMap();
  const duration = 8.4;
  const ease = (value) => { const x = Math.max(0, Math.min(1, value)); return x * x * (3 - 2 * x); };
  const mix = (a, b, progress) => a + (b - a) * progress;
  const polygon = (a, b, progress) => a.map((point, index) => `${index ? 'L' : 'M'}${mix(point[0], b[index][0], progress).toFixed(2)} ${mix(point[1], b[index][1], progress).toFixed(2)}`).join(' ') + 'Z';
  const sample = (time) => ({
    insert: ease((time - .65) / 1.85),
    backFold: ease((time - 2.6) / .65),
    frontFold: ease((time - 3.05) / .65),
    tape: ease((time - 3.6) / .35),
    bag: ease((time - 3.85) / .5),
    pack: ease((time - 4.45) / 1.7),
    seal: ease((time - 6.25) / .8),
    lift: ease((time - 7.15) / 1.05),
    done: ease((time - 7.85) / .45),
    stage: time < 2.6 ? 1 : time < 4.45 ? 2 : 3
  });
  const initialize = (root) => {
    root.querySelectorAll('[data-kiss-packaging]').forEach((element) => {
      if (controllers.has(element)) return;
      const find = (name) => element.querySelector(`[data-pk-${name}]`);
      const parts = Object.fromEntries(['stage', 'retail', 'carton', 'back-lid', 'front-lid', 'tape', 'bag-back', 'bag-front', 'seal-back', 'seal-front', 'seam', 'complete'].map((name) => [name, find(name)]));
      const control = element.querySelector('[data-pk-replay]');
      const steps = element.querySelectorAll('[data-pk-step]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const events = new AbortController();
      let elapsed = duration, running = false, started = false, visible = false, previous = null, raf = 0, observer;
      const draw = (time) => {
        const s = sample(time);
        if (element.dataset.compact === 'true') {
          const cameraInsert = ease((time - .65) / 1.85);
          const cameraReveal = ease((time - 3.25) / .6);
          const cameraY = mix(mix(5, 125, cameraInsert), 280, s.pack) - 130 * s.lift;
          const cameraBottom = mix(mix(310, 315, cameraInsert), 478, cameraReveal) - 130 * s.lift;
          const cameraHeight = cameraBottom - cameraY;
          element.querySelector('.kiss-packaging__art').setAttribute('viewBox', '94 ' + cameraY + ' 308 ' + cameraHeight);
        }
        parts.stage.setAttribute('transform', `translate(0 ${-130 * s.lift})`);
        parts.retail.setAttribute('transform', `translate(0 ${155 * s.insert})`);
        parts.carton.setAttribute('transform', `translate(0 ${164 * s.pack})`);
        parts['back-lid'].setAttribute('d', polygon([[164,173],[348,173],[355,144],[171,144]], [[164,173],[348,173],[326,194],[142,194]], s.backFold));
        parts['front-lid'].setAttribute('d', polygon([[142,194],[326,194],[312,219],[128,219]], [[142,194],[326,194],[348,173],[164,173]], s.frontFold));
        parts.tape.setAttribute('opacity', s.tape);
        parts['bag-back'].setAttribute('opacity', s.bag);
        parts['bag-front'].setAttribute('opacity', s.bag);
        parts['seal-back'].setAttribute('d', polygon([[120,313],[371,313],[369,284],[124,284]], [[120,313],[371,313],[368,339],[124,339]], s.seal));
        parts['seal-front'].setAttribute('opacity', s.seal);
        parts.seam.setAttribute('opacity', s.seal);
        parts.complete.setAttribute('opacity', s.done);
        element.dataset.stage = String(s.stage);
        steps.forEach((step, index) => {
          step.classList.toggle('is-current', index + 1 === s.stage);
          step.classList.toggle('is-complete', index + 1 < s.stage || s.done === 1);
        });
      };
      const queue = () => { if (!raf && running && visible && !document.hidden) raf = requestAnimationFrame(tick); };
      const tick = (now) => {
        raf = 0;
        if (!element.isConnected) { dispose(); return; }
        if (!running || !visible || document.hidden) { previous = null; return; }
        if (previous !== null) elapsed = Math.min(duration, elapsed + Math.max(0, now - previous) / 1000);
        previous = now;
        draw(elapsed);
        if (elapsed >= duration) { running = false; previous = null;  } else queue();
      };
      const start = (explicit = false) => {
        if (reduced.matches && !explicit) return;
        elapsed = 0; previous = null; running = true; started = true;
        draw(0);  queue();
      };
      const dispose = () => {
        cancelAnimationFrame(raf);
        observer?.disconnect();
        events.abort();
        controllers.delete(element);
      };
      control.addEventListener('click', () => start(true), { signal: events.signal });
      document.addEventListener('visibilitychange', () => { previous = null; queue(); }, { signal: events.signal });
      reduced.addEventListener('change', () => {
        
        if (reduced.matches) { running = false; elapsed = duration; cancelAnimationFrame(raf); raf = 0; draw(duration);  }
      }, { signal: events.signal });
      controllers.set(element, { dispose });
      draw(duration);  
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          visible = entries.some((entry) => entry.isIntersecting);
          previous = null;
          if (visible && !started && !reduced.matches) start();
          else if (visible) queue();
          else { cancelAnimationFrame(raf); raf = 0; }
        }, { threshold: .2 });
        observer.observe(element);
      } else { visible = true; if (!reduced.matches) start(); }
    });
  };
  document.addEventListener('kiss:packaging-mount', (event) => initialize(event.target));
  document.addEventListener('kiss:packaging-unmount', (event) => event.target.querySelectorAll('[data-kiss-packaging]').forEach((element) => controllers.get(element)?.dispose()));
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-kiss-packaging]').forEach((element) => controllers.get(element)?.dispose()));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-product-adviser"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kiss-preset-bot')) {
  customElements.define('kiss-preset-bot', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button) return;
        const dialog = this.querySelector('dialog');
        if (button.hasAttribute('data-bot-open')) { this.opener = button; dialog.showModal(); return; }
        if (button.hasAttribute('data-bot-close')) { dialog.close(); return; }
        const key = button.dataset.botQuestion;
        if (!key) return;
        const source = this.querySelector('template[data-bot-answer="' + key + '"]');
        if (!source) return;
        const log = this.querySelector('.kiss-bot-log');
        const question = document.createElement('div');
        question.className = 'kiss-bot-message kiss-bot-message--user';
        question.textContent = button.textContent;
        const answer = document.createElement('div');
        answer.className = 'kiss-bot-message';
        answer.append(source.content.cloneNode(true));
        if (key === 'package') {
          this.packageCount = (this.packageCount || 0) + 1;
          const ids = new Map();
          answer.querySelectorAll('[id]').forEach(node => { const old = node.id; node.id = old + '-chat-' + this.packageCount; ids.set(old, node.id); });
          answer.querySelectorAll('*').forEach(node => {
            for (const attr of Array.from(node.attributes)) {
              let value = attr.value;
              ids.forEach((next, old) => { value = value.split('url(#' + old + ')').join('url(#' + next + ')'); });
              if (value !== attr.value) node.setAttribute(attr.name, value);
            }
          });
        }
        log.append(question, answer);
        if (key === 'package') answer.dispatchEvent(new CustomEvent('kiss:packaging-mount', { bubbles: true }));
        while (log.children.length > 21) {
          log.firstElementChild.dispatchEvent(new CustomEvent('kiss:packaging-unmount', { bubbles: true }));
          log.firstElementChild.remove();
        }
        log.scrollTop += answer.getBoundingClientRect().top - log.getBoundingClientRect().top - (parseFloat(getComputedStyle(log).paddingTop) || 0);
      });
      this.querySelector('dialog').addEventListener('close', () => this.opener?.focus());
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kiss-theme-toggle"] && !Shopify.designMode) return;
  try {
    if (!window.kissAppearanceInitialized) {
    window.kissAppearanceInitialized = true;
    const sync = () => {
      const light = document.documentElement.dataset.kissTheme === 'light';
      document.querySelectorAll('[data-kiss-theme-toggle]').forEach(toggle => {
        toggle.setAttribute('aria-pressed', String(light));
        toggle.title = light ? toggle.dataset.darkLabel : toggle.dataset.lightLabel;
      });
    };
    sync();
    document.addEventListener('DOMContentLoaded', sync, { once: true });
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('click', event => {
      if (!event.target.closest('[data-kiss-theme-toggle]')) return;
      const next = document.documentElement.dataset.kissTheme === 'light' ? 'dark' : 'light';
      document.documentElement.dataset.kissTheme = next;
      try { localStorage.setItem('kiss-theme-v2', next); } catch (_) {}
      sync();
    });
    window.addEventListener('storage', event => {
      if (event.key !== 'kiss-theme-v2') return;
      document.documentElement.dataset.kissTheme = event.newValue === 'dark' ? 'dark' : 'light';
      sync();
    });
  }

  if (!window.kissCatalogHintInitialized) {
    window.kissCatalogHintInitialized = true;
    const checkCatalogOverflow = () => {
      document.querySelectorAll('#header-group .menu-list__submenu-inner').forEach(panel => {
        if (!panel.querySelector('.mega-menu__list') || panel.clientHeight === 0) return;
        let hint = panel.querySelector(':scope > .kiss-menu-scroll-hint');
        if (!hint) {
          hint = document.createElement('button');
          hint.type = 'button';
          hint.className = 'kiss-menu-scroll-hint button-unstyled';
          hint.textContent = 'Diğer kategorileri görmek için aşağı kaydır ↓';
          hint.addEventListener('click', () => {
            const atEnd = panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 8;
            panel.scrollBy({top: atEnd ? -panel.scrollHeight : Math.max(140, panel.clientHeight * .65), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          });
          panel.append(hint);
          panel.addEventListener('scroll', () => {
            const atEnd = panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 8;
            hint.textContent = atEnd ? 'Tüm kategoriler yukarıda ↑' : 'Diğer kategorileri görmek için aşağı kaydır ↓';
          }, {passive: true});
        }
        panel.dataset.kissOverflow = 'false';
        panel.dataset.kissOverflow = String(panel.scrollHeight > panel.clientHeight + 8);
      });
    };
    document.addEventListener('pointerover', event => {
      if (event.target.closest('#header-group')) requestAnimationFrame(checkCatalogOverflow);
    });
    document.addEventListener('focusin', event => {
      if (event.target.closest('#header-group')) setTimeout(checkCatalogOverflow, 200);
    });
    window.addEventListener('resize', checkCatalogOverflow);
    document.addEventListener('shopify:section:load', checkCatalogOverflow);
  }
  } catch(e) { console.error(e); }
})();

})();
